var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":(_vm.value == null) ? 'grey' : ((_vm.value) ? 'success' : 'error'),"dark":"","small":""}},[_vm._v(_vm._s((_vm.value == null) ? '・・・' : ((_vm.value) ? _vm.textTrue : _vm.textFalse)))])}
var staticRenderFns = []

export { render, staticRenderFns }